
/***
 * adds the item to ignoreList
 * @param item bson document
 * @returns {Promise<Response>} json
 */
export function addKeywordItem(item) {

    return fetch(`${process.env.REACT_APP_BASE_URI}/addkeyword`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        body: JSON.stringify(item)
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

/***
 * deletes an item from the ignoreList
 * @param id index Object ID
 * @returns {Promise<Response>} Error or success
 */
export function deleteKeywordItem(id) {

    return fetch(`${process.env.REACT_APP_BASE_URI}/deletekeyword/` + id, {
        method: 'DELETE',
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

/***
 * Get all items from the ignore list
 * @returns {Promise<Response>} Array of objects
 */
export function getKeywordList() {

    return fetch(`${process.env.REACT_APP_BASE_URI}/keywordlist`, {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
        },
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}